"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M16.007 7a.5.5 0 0 1-.416-.777c.668-1.002.37-1.606-.044-2.441V3.78c-.442-.894-.99-2.005.044-3.558a.5.5 0 0 1 .832.554c-.715 1.073-.39 1.73.02 2.56.433.872.97 1.958-.02 3.44a.496.496 0 0 1-.416.224ZM7.76 6.914a.498.498 0 0 0 .693-.139c.99-1.482.453-2.568.02-3.44-.41-.83-.734-1.487-.02-2.56a.5.5 0 0 0-.83-.554c-1.037 1.552-.487 2.664-.045 3.557v.002c.413.835.711 1.439.044 2.441a.5.5 0 0 0 .138.693Zm3.984 0a.5.5 0 0 0 .693-.139c.99-1.482.454-2.568.022-3.44-.413-.83-.737-1.487-.022-2.56a.5.5 0 0 0-.832-.554c-1.034 1.553-.485 2.664-.044 3.557l.001.003c.413.835.711 1.439.043 2.44a.5.5 0 0 0 .14.693ZM3.486 22h1.5v1.5a.5.5 0 0 0 1 0V22H18v1.5a.5.5 0 0 0 1 0V22h1.484c1.38 0 2.5-1.122 2.5-2.5v-9c0-1.378-1.12-2.5-2.5-2.5h-17a2.503 2.503 0 0 0-2.5 2.5v9c0 1.378 1.121 2.5 2.5 2.5h.002ZM18.5 21H3.484c-.827 0-1.5-.673-1.5-1.5v-9c0-.827.673-1.5 1.5-1.5h17c.827 0 1.5.673 1.5 1.5v9c0 .827-.673 1.5-1.5 1.5H18.5ZM4.484 19.992a.5.5 0 0 1-.5-.5v-9a.5.5 0 1 1 1 0v9a.5.5 0 0 1-.5.5Zm2.5-.5a.5.5 0 0 0 1 0v-9a.5.5 0 1 0-1 0v9Zm3.5.5a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 1 0v9a.5.5 0 0 1-.5.5Zm2.5-.5a.5.5 0 0 0 1 0v-9a.5.5 0 1 0-1 0v9Zm3.5.5a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 1 0v9a.5.5 0 0 1-.5.5Zm2.5-.5a.5.5 0 0 0 1 0v-9a.5.5 0 1 0-1 0v9Z",
    clipRule: "evenodd"
  })]
});